import { ANNOTATION_ICON, cn, IMG_COMMERCIAL_SERVICES_REFERENCES_BG, IMG_FAQ_BANNER, IMG_P2P_ENERGY_OUR_PRODUCTS, SECTION_BG, WELCOME_SERVICE_BG } from "src/helpers";
import { fetchProjectsSummaryApiRequest } from "src/services/requests/CommercialAndIndustrial";
import CounterAnimation from "src/shadcn/components/custom/Animations/CounterAnimation";
import { REFERENCES_ANALYSIS } from "../../Services/Component/modules";
import useFetchData from "../../Services/useHandleGetTop5Products";
import { useNavigate } from "react-router-dom";
import { MAIN_ROUTES_CONST } from "src/navigations/modules";
import logo1 from "../../../../assets/sunsure.png";
import logo2 from "../../../../assets/sunsource.png";
import logo3 from "../../../../assets/forthEnergyPartner.png";
import logo4 from "../../../../assets/radiance.png";
import logo5 from "../../../../assets/heroFutureEnergy.png";
import logo6 from "../../../../assets/tataPower.png";




const OurPartners = () => {
    const navigate = useNavigate();
    const backgroundImg = SECTION_BG
    const logos = [logo1, logo2, logo3, logo4, logo5, logo6];



    return (
        <div
            id="welcome-p2p-energy-section"
            className="w-full h-[300px] font-sans  flex flex-col justify-center max-sm:items-center space-y-12"
            style={{
                background: `url(${backgroundImg})`,
                backgroundSize: "cover",
            }}
        >
            <div className="px-16">
                <div className="flex items-center space-x-2">
                    {" "}
                    <img src={ANNOTATION_ICON} style={{ width: "20px", height: "20px" }} alt="ANNOTATION_ICON" />{" "}
                    <span className=" font-bold text-3xl ">Our Partners</span>
                </div>
                <div className="px-[30px]">We work with the best partners to deliver the best results.</div>
            </div>
            <div className="px-8 md:px-16   space-y-8">
                <div className="overflow-x-auto ">
                    <div className="flex justify-center space-x-6 px-6 w-max mx-auto">
                        {logos.map((logo, index) => (
                            <div
                                key={index}
                                className="flex-shrink-0 w-50 h-30 bg-white rounded shadow flex items-center justify-center p-4"
                            >
                                <img src={logo} alt={`Partner ${index + 1}`} className="max-h-16 object-contain" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurPartners;
